import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
    selector: 'app-clock-in-out-error',
    templateUrl: './clock-in-out-error.component.html',
    styleUrls: ['./clock-in-out-error.component.css'],
    standalone: false
})
export class ClockInOutErrorComponent implements OnInit {
  kioskLogin = false;
  params: any;

  constructor(
    private route: ActivatedRoute,
    private utilityService: UtilityService
  ) {}

  ngOnInit(): void {
    this.params = this.route.snapshot.queryParams;
    this.kioskLogin = this.params?.kioskLogin;
    this.redirectToLogin();
  }

  redirectToLogin() {
    setTimeout(() => {
      let loginURL = '/Account/Login';
      this.utilityService.isLoggedOut = true;
      if (this.kioskLogin) {
        window.location.href = '/Account/Logout?kioskLogout=true';
        loginURL = '/Account/Kiosklogin';
      } else {
        window.location.href = '/Account/Logout';
      }
      window.history.replaceState(null, null, loginURL);
    }, 5000);
  }
}
